import React, { useRef } from 'react';
import { Button, Typography } from '@material-ui/core';
import RepeatRounded from '@material-ui/icons/RepeatRounded';

import { JobSummary } from '../../../../components/JobSummary';
import { PublishableStatusComponent } from '../../../../components/PublishableStatusComponent';

import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';
import { GQLJobSummary, GQLPieceModel } from '@jewelutions/core-crm-server-api-client-domain';
import { ImageCarousel } from '../../../../components';
import { successNotification } from '../../../../core/utils';
import { toast } from 'react-toastify';

interface IProps {
  pieceId: string;
  model: GQLPieceModel;
}

const ModelDetailsImages: React.FC<IProps> = ({ pieceId, model }) => {
  const imagesImportJobsRef = useRef(null);

  const [
    regeneratePieceImages,
    { error, loading }
  ] = GQLOperationBuilder.piece.computeAndImportPieceModelImage();

  const {
    data: imageJobSummaryData,
    refetch: imageJobSummaryRefetch
  } = GQLOperationBuilder.piece.computeAndImportPieceModelImageJobs({
    pieceId: pieceId,
    pieceModelId: model.id
  });

  let images = model.images.filter(imagesConfig => {
    return !!model.availableConfigurations.find(imgC => {
      return (
        imgC.sizeType === imagesConfig.configuration.sizeType &&
        imgC.platingType === imagesConfig.configuration.platingType &&
        imgC.materialType === imagesConfig.configuration.materialType &&
        imgC.stonesPlacementType === imagesConfig.configuration.stonesPlacementType
      );
    });
  });

  return (
    <React.Fragment>
      <Typography variant="h6">Piece images</Typography>
      <PublishableStatusComponent
        status={model.hasImagesValid}
        text="Piece model images validity"
      ></PublishableStatusComponent>
      <span>Last model CAD import job status: </span>
      <JobSummary
        ref={imagesImportJobsRef}
        jobSummary={
          GQLOperationBuilder.piece.jobSummaryArrayFromResponse(imageJobSummaryData).length > 0
            ? GQLOperationBuilder.piece.jobSummaryArrayFromResponse(imageJobSummaryData)[0]
            : ((undefined as unknown) as GQLJobSummary)
        }
      />
      {model.hasCadFileValid && (
        <Button
          size="small"
          color="primary"
          variant={'contained'}
          onClick={() => {
            regeneratePieceImages({
              variables: {
                pieceId: pieceId,
                pieceConfigurations: model.availableConfigurations.map(ac => {
                  return {
                    materialType: ac.materialType,
                    platingType: ac.platingType,
                    sizeType: ac.sizeType,
                    stonesPlacementType: ac.stonesPlacementType
                  };
                })
              }
            }).then(_result => {
              successNotification(toast, 'Image generation job scheduled succesfully.', () => {});
              imageJobSummaryRefetch();
            });
          }}
        >
          <RepeatRounded />
          Regenerate images
        </Button>
      )}
      {images.length > 0 && <ImageCarousel images={images.map(i => i.image.media.url!)} />}
    </React.Fragment>
  );
};

export default ModelDetailsImages;
